import { Messages } from "../types";

export const es: Messages = {
    /* Verbs and nouns shared by every screen ------------------------------ */
    "common.add": "Añadir",
    "common.assign": "Asignar",
    "common.back": "Atrás",
    "common.cancel": "Cancelar",
    "common.clear": "Quitar selección",
    "common.confirm": "Confirmar",
    "common.continue": "Continuar",
    "common.delete": "Eliminar",
    "common.menu": "Menú",
    "common.open": "Abrir",
    "common.refresh": "Actualizar",
    "common.remove": "Retirar",
    "common.retry": "Reintentar",
    "common.save": "Guardar",
    "common.search": "Buscar",
    "common.signIn": "Iniciar sesión",
    "common.signOut": "Cerrar sesión",

    /* Navigation ---------------------------------------------------------- */
    "nav.group.clinic": "Clínica",
    "nav.doctors": "Médicos",
    "nav.caretakers": "Cuidadores",
    "nav.patients": "Pacientes",
    "nav.role": "Administrador de la organización",
    "sidebar.collapse": "Contraer el menú",
    "sidebar.expand": "Expandir el menú",

    /* Language switcher --------------------------------------------------- */
    "language.label": "Idioma",

    /* Turned-away session ------------------------------------------------- */
    "access.denied.title": "Acceso denegado",
    "access.denied.subtitle":
        "Esta consola es para administradores de la organización. Inicia sesión con una cuenta de administrador de la organización.",

    /* Command palette ----------------------------------------------------- */
    "palette.placeholder": "Ir a una sección…",
    "palette.aria": "Ir a una sección",
    "palette.empty": "Sin resultados",
    "palette.section.sections": "Secciones",
    "palette.section.actions": "Acciones",
    "palette.foot.move": "para moverse",
    "palette.foot.open": "para abrir",

    /* Action bar ---------------------------------------------------------- */
    "crud.selected": "Seleccionado:",
    "crud.hint.default": "Elige una fila para abrirla",
    "crud.hint.assignPeople": "Marca las personas que quieres asignar",
    "crud.hint.removePatients": "Marca los pacientes que quieres retirar de esta lista",
    "crud.hint.removeCaretakers": "Marca los cuidadores que quieres retirar de esta lista",

    /* Table columns ------------------------------------------------------- */
    "person.column.firstName": "Nombre",
    "person.column.lastName": "Apellidos",
    "person.column.phone": "Teléfono",
    "person.column.email": "Correo",

    /* Form labels --------------------------------------------------------- */
    "person.field.firstName": "Nombre:",
    "person.field.lastName": "Apellidos:",
    "person.field.phone": "Número de teléfono:",
    "person.field.email": "Correo electrónico:",
    "person.field.password": "Contraseña:",
    "person.field.gender": "Sexo:",
    "person.field.birthday": "Fecha de nacimiento:",
    "person.field.country": "País:",
    "person.field.address": "Dirección:",
    "person.field.address2": "Dirección, línea 2:",
    "person.field.city": "Ciudad:",
    "person.field.state": "Provincia:",
    "person.field.postcode": "Código postal:",
    "person.field.allowedDistance": "Distancia permitida:",
    "person.field.checkAllowedDistance": "Comprobar la distancia:",
    "person.field.doctorFirstName": "Nombre del médico:",
    "person.field.doctorLastName": "Apellidos del médico:",
    "person.field.doctorPhone": "Teléfono del médico:",
    "person.field.diagnosis": "Diagnóstico:",

    /* Field examples ------------------------------------------------------ */
    "person.placeholder.firstName": "Juan",
    "person.placeholder.lastName": "Pérez",
    "person.placeholder.phone": "1 (344) 333-3333",
    "person.placeholder.email": "john.doe@email.com",
    "person.placeholder.password": "contraseña",
    "person.placeholder.country": "Escribe para buscar",
    "person.placeholder.address": "Calle Mayor 27",
    "person.placeholder.address2": "Puerta izquierda",
    "person.placeholder.city": "Madrid",
    "person.placeholder.state": "Madrid",
    "person.placeholder.postcode": "28001",
    "person.placeholder.doctorFirstName": "Miguel",
    "person.placeholder.doctorLastName": "Santos",
    "person.placeholder.doctorPhone": "+1 456 565-3443",
    "person.placeholder.diagnosis": "Diagnóstico",

    /* Field validation ---------------------------------------------------- */
    "person.rule.firstName": "introduce el nombre",
    "person.rule.phone": "introduce el número de teléfono",
    "person.rule.email": "introduce un correo electrónico válido",
    "person.rule.code": "introduce el código",

    /* Enumerated values --------------------------------------------------- */
    "person.gender.male": "Hombre",
    "person.gender.female": "Mujer",
    "person.gender.other": "Otro",

    "patient.hint.allowedDistance": "Metros desde casa antes de generar una alerta.",

    /* Search fields ------------------------------------------------------- */
    "list.search.person": "Buscar por nombre, teléfono o correo",
    "list.search.people": "Buscar personas",
    "list.search.patients": "Buscar pacientes",
    "list.search.caretakers": "Buscar cuidadores",

    /* Empty lists --------------------------------------------------------- */
    "empty.default.title": "Aquí no hay nada todavía",
    "empty.default.hint": "Los registros que añadas aparecerán en esta lista.",
    "empty.assign.title": "No queda nadie por asignar",
    "empty.assign.hint": "Todas las personas disponibles ya están en esta lista.",
    "empty.patients.title": "Sin pacientes asignados",
    "empty.patients.hint": "Asigna pacientes para verlos aquí.",
    "empty.caretakers.title": "Sin cuidadores asignados",
    "empty.caretakers.hint": "Asigna cuidadores para verlos aquí.",

    /* Record tabs --------------------------------------------------------- */
    "tabs.doctor": "Médico",
    "tabs.caretaker": "Cuidador",
    "tabs.patients": "Pacientes",
    "tabs.caretakers": "Cuidadores",

    /* Records ------------------------------------------------------------- */
    "doctor.new": "Nuevo médico",
    "doctor.one": "Médico",
    "caretaker.new": "Nuevo cuidador",
    "caretaker.one": "Cuidador",
    "patient.new": "Nuevo paciente",
    "patient.one": "Paciente",

    /* Assignment ---------------------------------------------------------- */
    "assign.eyebrow": "Asignar",
    "assign.people.title": "Asignar personas",
    "assign.caretakers.title": "Asignar cuidadores",
    "assign.patients.title": "Asignar pacientes",
    "assign.caretakers.forDoctor": "Cuidadores aún no asignados a este médico.",
    "assign.patients.forDoctor": "Pacientes aún no asignados a este médico.",
    "assign.patients.forCaretaker": "Pacientes aún no asignados a este cuidador.",
    "assign.selection.count": {
        one: "{count} persona",
        other: "{count} personas"
    },

    /* Confirmations ------------------------------------------------------- */
    "confirm.remove.title": "¿Retirar de la clínica?",
    "confirm.remove.doctor":
        "¿Seguro que quieres retirar de la clínica al médico «{name}»? Su cuenta se mantiene, pero deja esta organización.",
    "confirm.remove.caretaker":
        "¿Seguro que quieres retirar de la clínica al cuidador «{name}»? Su cuenta se mantiene, pero deja esta organización.",
    "confirm.remove.patient":
        "¿Seguro que quieres retirar de la clínica al paciente «{name}»? Su cuenta se mantiene, pero deja esta organización.",
    "confirm.delete.title": "¿Eliminar de forma permanente?",
    "confirm.delete.doctor":
        "¿Seguro que quieres eliminar por completo al médico «{name}»? Esta acción no se puede deshacer.",
    "confirm.delete.caretaker":
        "¿Seguro que quieres eliminar por completo al cuidador «{name}»? Esta acción no se puede deshacer.",
    "confirm.delete.patient":
        "¿Seguro que quieres eliminar por completo al paciente «{name}»? Esta acción no se puede deshacer.",

    /* Failures ------------------------------------------------------------ */
    "auth.failed.title": "Error de autenticación",
    "auth.failed.body": "Tu sesión ya no es válida, inicia sesión de nuevo.",
    "error.server": "Error del servidor",

    /* Account ------------------------------------------------------------- */
    "account.title": "Cuenta",
    "account.email": "Correo electrónico",
    "account.notAuthenticated": "Sin autenticar",

    /* Adding a patient ---------------------------------------------------- */
    "addPatient.eyebrow": "Añadir paciente",
    "addPatient.pageTitle": "Añadir paciente",
    "addPatient.phone.title": "Número de teléfono",
    "addPatient.phone.hint":
        "Enviamos un código de un solo uso a este número para confirmar que pertenece al paciente.",
    "addPatient.phone.label": "Número de teléfono",
    "addPatient.phone.help": "Incluye el prefijo del país.",
    "addPatient.sendCode": "Enviar código",
    "addPatient.cannotAdd.title": "No se puede añadir el paciente",
    "addPatient.exists.own": "Este paciente ya existe en nuestra clínica.",
    "addPatient.exists.other": "Este paciente ya existe en otra clínica.",
    "addPatient.code.title": "Código de activación",
    "addPatient.code.hint":
        "Introduce el código de ocho caracteres que aparece en la aplicación del paciente.",
    "addPatient.code.label": "Código",
    "addPatient.code.placeholder": "XXXX-XXXX",
    "addPatient.confirm.title": "Confirma el número",
    "addPatient.confirm.hint":
        "Hemos enviado un código de seis dígitos por SMS. Introdúcelo para confirmar que el número pertenece al paciente.",
    "addPatient.confirm.pageTitle": "Confirmar el número de teléfono",
    "addPatient.otp.label": "Código",
    "addPatient.otp.help": "Seis dígitos.",
    "addPatient.otp.placeholder": "xxx-xxx",
    "addPatient.resend": "Enviar de nuevo",
    "addPatient.resendPrompt": "¿No has recibido el mensaje? Reenviar en",
    "addPatient.resendSeconds": "{seconds} s",

    /* Reference screen ---------------------------------------------------- */
    "countries.eyebrow": "Referencia",
    "countries.title": "Países",
    "countries.subtitle":
        "Una ayuda de desarrollo: la lista de países que usa el formato de números de teléfono."
};
